(function () {
  if (window.__ampCartBridgeInitialized) return;
  window.__ampCartBridgeInitialized = true;

  var openLock = false;
  var openLockTimer;

  function isAmpCartAvailable() {
    return typeof window.SLIDECART_UPDATE === 'function' && typeof window.SLIDECART_OPEN === 'function';
  }

  function isCartOpen() {
    var root = document.getElementById('slidecarthq');
    return Boolean(root && root.classList.contains('is-open'));
  }

  function isCartAddRequest(url) {
    return Boolean(url && /\/cart\/add(\.js)?/.test(String(url)));
  }

  function isCartPageUrl(url) {
    var value = String(url || '');
    return /\/cart\/?([?#]|$)/.test(value) && !/\/cart\/add/.test(value);
  }

  function blockCartPageRedirect() {
    var originalAssign = window.location.assign;
    var originalReplace = window.location.replace;
    var blocked = true;

    window.location.assign = function (url) {
      if (blocked && isCartPageUrl(url)) return;
      return originalAssign.call(window.location, url);
    };

    window.location.replace = function (url) {
      if (blocked && isCartPageUrl(url)) return;
      return originalReplace.call(window.location, url);
    };

    window.setTimeout(function () {
      blocked = false;
      window.location.assign = originalAssign;
      window.location.replace = originalReplace;
    }, 750);
  }

  function openAmpCart(options) {
    if (!isAmpCartAvailable() || openLock) return;

    var shouldOpen = !options || options.open !== false;
    var alreadyOpen = isCartOpen();

    openLock = true;
    window.clearTimeout(openLockTimer);
    openLockTimer = window.setTimeout(function () {
      openLock = false;
    }, 600);

    if (!alreadyOpen) blockCartPageRedirect();

    window.SLIDECART_UPDATE(function () {
      if (shouldOpen && !alreadyOpen) window.SLIDECART_OPEN();
    });
  }

  function handleExternalCartAdd() {
    openAmpCart({ open: true });
  }

  function handleInCartAdd() {
    openAmpCart({ open: false });
  }

  function patchFetch() {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function' || nativeFetch.__ampCartBridgePatched) return;

    function patchedFetch(input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var responsePromise = nativeFetch.apply(this, arguments);

      if (isCartAddRequest(url)) {
        var fromAmpCart = Boolean(
          document.getElementById('slidecarthq') &&
            document.activeElement &&
            document.getElementById('slidecarthq').contains(document.activeElement)
        );

        responsePromise.then(function (response) {
          if (!response.ok) return;
          if (fromAmpCart) handleInCartAdd();
          else handleExternalCartAdd();
        });
      }

      return responsePromise;
    }

    patchedFetch.__ampCartBridgePatched = true;
    window.fetch = patchedFetch;
  }

  function patchXHR() {
    if (window.XMLHttpRequest.prototype.__ampCartBridgePatched) return;

    var nativeOpen = window.XMLHttpRequest.prototype.open;
    var nativeSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__ampCartAddUrl = url;
      return nativeOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = xhr.__ampCartAddUrl;

      if (isCartAddRequest(url)) {
        xhr.addEventListener('load', function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          handleExternalCartAdd();
        });
      }

      return nativeSend.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.__ampCartBridgePatched = true;
  }

  function chainCallback(name, fn) {
    var previous = window[name];
    window[name] = function () {
      if (typeof previous === 'function') previous.apply(this, arguments);
      fn.apply(this, arguments);
    };
  }

  patchFetch();
  patchXHR();

  chainCallback('SLIDECART_UPSELL_ADD', handleInCartAdd);
  chainCallback('SLIDECART_ADD_TO_CART', function () {
    if (isCartOpen()) handleInCartAdd();
    else handleExternalCartAdd();
  });
})();
